import React, { useEffect, useRef, useState } from 'react';
import { Tab, Nav } from 'react-bootstrap';
import TradeSocketLow from './TradeSocketLow';
import TradeSocketHigh from './TradeSocketHigh';
import { useDispatch, useSelector } from 'react-redux';
import configuration from "react-global-configuration";
import { currencyPairPrice } from '../../../store/actions/BuyAction';

const TradeSocket = () => {
    const [buyTrade, setBuyTrade] = useState([]);
    const [sellTrade, setSellTrade] = useState([]);
    const currencyPair = useSelector((state) => state.buy.currencyPair);
    const profile = useSelector((state) => state.user.profile);
    const dispatch = useDispatch()
    const [isValid, setValid] = useState(true);
    // const [exchangeRate, setExchangeRate] = useState(0);
    // const [count, setCount] = useState(0);
    // const messageCount = useRef(0);



    useEffect(() => {
        if (currencyPair) {
            if ((["USDT-USD", "USDT-EUR", "USDC-USD", "USDC-EUR"].includes(currencyPair?.unique_id))) {
                const cryptoExchangeUrl = process.env.REACT_APP_SOCKET_URL != ""
                    ? process.env.REACT_APP_SOCKET_URL
                    : "wss://cms-proexchange.rare-able.com:3091";

                const socket = new WebSocket(cryptoExchangeUrl);
                socket.onopen = () => {
                    const subscribeMessage = JSON.stringify({
                        type: "order-book",
                        pair: currencyPair?.unique_id,
                    });
                    socket.send(subscribeMessage);
                }
                socket.onmessage = (event) => {
                    const parsedData = JSON.parse(event.data);
                    setBuyTrade(
                        parsedData?.buy?.map(([price, value]) => ({
                            price: price,
                            value: value,
                        }))
                    );

                    setSellTrade(
                        parsedData?.sell?.map(([price, value]) => ({
                            price: price,
                            value: value,
                        }))
                    );
                    const lowestBuyPrice = parsedData?.buy?.[parsedData?.buy?.length - 1]?.[0];
                    const lowestSellPrice = parsedData?.sell?.[parsedData?.sell?.length - 1]?.[0];
                    dispatch(currencyPairPrice({ buyPrice: lowestBuyPrice, sellPrice: lowestSellPrice }))
                };
                return () => {
                    if (socket) {
                        socket.close();
                    }
                };
            }
            else {
                let ws
                let bookTickerWs
                let currencyPairs = currencyPair?.unique_id.split('-').join("").toLowerCase()
                const checkSymbolValidity = async (symbol) => {
                    const response = await fetch(`https://api.binance.com/api/v3/exchangeInfo`);
                    const data = await response.json();
                    const symbolExists = data.symbols.some(s => s.symbol === symbol.toUpperCase());

                    if (symbolExists) {

                        setValid(true)
                    } else {
                        setValid(false)
                        currencyPairs = currencyPair?.unique_id.split('-').reverse().join("").toLowerCase()
                    }
                };

                checkSymbolValidity(currencyPairs).then(isValid => {
                    ws = new WebSocket(`wss://stream.binance.com:9443/ws/${currencyPairs}@depth`);

                    ws.onmessage = (event) => {
                        const parsedData = JSON.parse(event.data);
                        setBuyTrade(
                            parsedData?.b?.map(([price, value]) => ({
                                price: price,
                                value: value,
                            }))
                        );

                        setSellTrade(
                            parsedData?.a?.map(([price, value]) => ({
                                price: price,
                                value: value,
                            }))
                        );
                    }

                    bookTickerWs = new WebSocket(`wss://stream.binance.com:9443/ws/${currencyPairs}@bookTicker`);
                    bookTickerWs.onmessage = (event) => {
                        const parsedData = JSON.parse(event.data);
                         dispatch(currencyPairPrice({ buyPrice: parsedData?.b, sellPrice: parsedData?.a }))
                    }
                })

                return () => {
                    ws?.close();
                    bookTickerWs?.close();
                };
            }
        }

    }, [currencyPair]);

    return (
        <>
            <div className="trade-socket-wrapped">
                <div className="trade-socket-tabs">
                    <Tab.Container id="socket-trade" defaultActiveKey="bouble-stack">
                        <Nav variant="pills">
                            <Nav.Item>
                                <Nav.Link eventKey="bouble-stack">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="22"
                                        fill="none"
                                        viewBox="0 0 22 19"
                                    >
                                        <path fill="#F23645" d="M0 .5h7v8H0z"></path>
                                        <path fill="#19CC5B" d="M0 9.5h7v9H0z"></path>
                                        <path fill="#fff" d="M8 .5h14v18H8z"></path>
                                    </svg>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="hight-stack">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="22"
                                        fill="none"
                                        viewBox="0 0 22 19"
                                    >
                                        <path fill="#19CC5B" d="M0 .5h7v18H0z"></path>
                                        <path fill="#fff" d="M8 .5h14v18H8z"></path>
                                    </svg>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="low-stack">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="22"
                                        fill="none"
                                        viewBox="0 0 22 19"
                                    >
                                        <path fill="#F23645" d="M0 .5h7v18H0z"></path>
                                        <path fill="#fff" d="M8 .5h14v18H8z"></path>
                                    </svg>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content>
                            <Tab.Pane eventKey="bouble-stack">
                                <div className="trade-stack-body">
                                    <div className="trade-stack-head">
                                        <div className="stack-price-label">Price({currencyPair?.currency2})</div>
                                        <div className="stack-amt-label">Amount({currencyPair?.currency1})</div>
                                    </div>
                                    <div className="trade-stack-frame">
                                        <div className="trade-stack-low-frame">

                                            <TradeSocketLow
                                                buyTrade={buyTrade}
                                                currencyPair={currencyPair}
                                            />

                                        </div>
                                        <div className="trade-batch"></div>
                                        <div className="trade-stack-hight-frame">


                                            <TradeSocketHigh
                                                sellTrade={sellTrade}
                                                currencyPair={currencyPair}
                                            />

                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="hight-stack">
                                <div className="trade-stack-body">
                                    <div className="trade-stack-head">
                                        <div className="stack-price-label">Price({currencyPair?.currency2})</div>
                                        <div className="stack-amt-label">Amount({currencyPair?.currency1})</div>
                                    </div>
                                    <div className="trade-stack-frame overflow-auto">

                                        <TradeSocketHigh
                                            sellTrade={sellTrade}
                                            currencyPair={currencyPair}
                                        />

                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="low-stack">
                                <div className="trade-stack-body">
                                    <div className="trade-stack-head">
                                        <div className="stack-price-label">Price({currencyPair?.currency2})</div>
                                        <div className="stack-amt-label">Amount({currencyPair?.currency1})</div>
                                    </div>
                                    <div className="trade-stack-frame overflow-auto">

                                        <TradeSocketLow
                                            sellTrade={sellTrade}
                                            currencyPair={currencyPair}
                                        />


                                    </div>
                                </div>

                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </div>
        </>
    )
}

export default TradeSocket;